module.exports = __webpack_public_path__ + "images/34d0acccb739d3c1f700d79f043978f5.png";